import Constants from "@/services/Constants";
import axios from "axios";

export default {
	async post(action, key) {
		let res = await axios.post(`${Constants.sentinelBackend}/${action}/`, {key});
		return res.data;
	}
}